import { ChipNavigationMui } from '@mi-front/ui';
import { Box } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { VIDEO_EDITIONS_PROJECT_GROUP_QUERY_PARAM } from '../lib/video-editions-project-group-query-param';

const draftChipMessage = defineMessage({
  id: 'fragments.videoEditions.category.draftChip',
  defaultMessage: 'Borradores y en progreso ({count})',
});

const generatedChipMessage = defineMessage({
  id: 'fragments.videoEditions.category.generatedChip',
  defaultMessage: 'Generados ({count})',
});

export interface FragmentVideoEditionsCategoryChipsProps {
  /** Shown after the chips in the toolbar (e.g. create project). */
  header?: React.ReactNode;
  draftCount: number;
  generatedCount: number;
  draftContent: React.ReactNode;
  generatedContent: React.ReactNode;
}

/**
 * URL-driven chip navigation for draft vs generated video edition projects, built on ChipNavigationMui.
 */
export function FragmentVideoEditionsCategoryChips({
  header,
  draftCount,
  generatedCount,
  draftContent,
  generatedContent,
}: FragmentVideoEditionsCategoryChipsProps) {
  return (
    <ChipNavigationMui
      param={VIDEO_EDITIONS_PROJECT_GROUP_QUERY_PARAM}
      defaultActiveChip="draft"
      header={header}
      headerPosition="inline"
      chips={[
        {
          value: 'draft',
          label: <FormattedMessage {...draftChipMessage} values={{ count: draftCount }} />,
          content: <Box sx={{ mt: 2 }}>{draftContent}</Box>,
        },
        {
          value: 'generated',
          label: <FormattedMessage {...generatedChipMessage} values={{ count: generatedCount }} />,
          content: <Box sx={{ mt: 2 }}>{generatedContent}</Box>,
        },
      ]}
      sx={{ mb: 2 }}
    />
  );
}
